import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl } from "../../../Helper/BaseUrl";
import { toastErrorr, toastSuccesss } from "../../../Helper/ToastMessage";


// Get Table Data
export const STPBreakDownMaintainanceTableDataAPI = createAsyncThunk("STPBreakDownMaintainanceTableData", async ({ data }) => {
    const {
        M_FinancialYearID,
        M_MonthID,
        // ReadingDate,
        M_STP_UnitTypeID,
        M_STP_EquipmentTypeID,
        M_WardID,
        M_UserID,
        token,
        From,
        To,
        handleSTPBreakDownMaintainanceExport
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/APKDashboard/Get_WEB_STP_T_STP_BreakdownMaintenance_Select?M_FinancialYearID=${M_FinancialYearID ? M_FinancialYearID : '0'}&M_MonthID=${M_MonthID ? M_MonthID : '0'}&M_WardID=${M_WardID ? M_WardID : '0'}&M_STP_UnitTypeID=${M_STP_UnitTypeID ? M_STP_UnitTypeID : '0'}&M_STP_EquipmentTypeID=${M_STP_EquipmentTypeID ? M_STP_EquipmentTypeID : '0'}&M_UserID=${M_UserID}&From=${From}&To=${To}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            // console.log(result.data1, result.data) 
            if (result.code >= 200 && result.code <= 300 && result.data) {
                handleSTPBreakDownMaintainanceExport && handleSTPBreakDownMaintainanceExport()
                return result.data

            } else {
                return result
            }
        })
})

const STPBreakDownMaintainanceTableDataSlice = createSlice({
    name: "STPBreakDownMaintainanceTableData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(STPBreakDownMaintainanceTableDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(STPBreakDownMaintainanceTableDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(STPBreakDownMaintainanceTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const STPBreakDownMaintainanceTableDataReducer = STPBreakDownMaintainanceTableDataSlice.reducer

export const STPBreakDownMaintainanceTableExportDataAPI = createAsyncThunk("STPBreakDownMaintainanceTableExportData", async ({ data }) => {
    const {
        M_FinancialYearID,
        M_MonthID,
        // ReadingDate,
        M_STP_UnitTypeID,
        M_STP_EquipmentTypeID,
        M_WardID,
        M_UserID,
        token,
        From,
        To,
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/APKDashboard/Get_WEB_STP_T_STP_BreakdownMaintenance_Select?M_FinancialYearID=${M_FinancialYearID ? M_FinancialYearID : '0'}&M_MonthID=${M_MonthID ? M_MonthID : '0'}&M_WardID=${M_WardID ? M_WardID : '0'}&M_STP_UnitTypeID=${M_STP_UnitTypeID ? M_STP_UnitTypeID : '0'}&M_STP_EquipmentTypeID=${M_STP_EquipmentTypeID ? M_STP_EquipmentTypeID : '0'}&M_UserID=${M_UserID}&From=${From}&To=${To}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            // console.log(result.data1, result.data) 
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data

            } else {
                return result
            }
        })
})

const STPBreakDownMaintainanceExportDataSlice = createSlice({
    name: "STPBreakDownMaintainanceExportData",
    initialState: {
        isExportLoading: false,
        ExportTableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(STPBreakDownMaintainanceTableExportDataAPI.pending, (state, action) => {
            state.isExportLoading = true;
        });
        builder.addCase(STPBreakDownMaintainanceTableExportDataAPI.fulfilled, (state, action) => {
            state.isExportLoading = false;
            state.ExportTableData = action.payload;
        });
        builder.addCase(STPBreakDownMaintainanceTableExportDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isExportLoading = false;
            state.isError = true;
            state.ExportTableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const STPBreakDownMaintainanceTableExportDataReducer = STPBreakDownMaintainanceExportDataSlice.reducer


// export const STPMachineryOperationPostDataAPI = createAsyncThunk("STPMachineryOperationPostData", async ({ data }) => {
//     const {
//         T_STP_MachineryOperationID,
//         OperationHours,
//         CurrentAmp,
//         M_UserID,
//         token,
//         Flag,
//         handleIsPost,
//         handleClearField,
//         handleOnCloseClick,
//     } = data

//     var myHeaders = new Headers();
//     myHeaders.append("Authorization", "Bearer " + token);

//     var formdata = new FormData();
//     formdata.append("T_STP_MachineryOperationID", T_STP_MachineryOperationID);
//     formdata.append("OperationHours", OperationHours);
//     formdata.append("CurrentAmp", CurrentAmp);
//     formdata.append("M_UserID", M_UserID);

//     var requestOptions = {
//         method: 'PATCH',
//         headers: myHeaders,
//         body: formdata,
//         redirect: 'follow'
//     };

//     fetch(`${BaseUrl}/APKDashboard/Post_WEB_STP_T_STP_MachineryOperation_Update`, requestOptions)
//         .then((res) => res.json())
//         .then((result) => {
//             if (result.code >= 200 && result.code <= 300 && result.data) {
//                 handleIsPost()
//                 // handleClearField()
//                 handleOnCloseClick()
//                 toastSuccesss(result.message)
//                 return result.data
//             } else {
//                 toastErrorr(result.message)
//             }
//             return result
//         })
// })

// const STPMachineryOperationPostDataSlice = createSlice({
//     name: "STPMachineryOperationPostData",
//     initialState: {
//         isLoading: false,
//         tableData: null,
//         isError: false,
//     },
//     extraReducers: (builder) => {
//         builder.addCase(STPMachineryOperationPostDataAPI.pending, (state, action) => {
//             state.isLoading = true;
//         });
//         builder.addCase(STPMachineryOperationPostDataAPI.fulfilled, (state, action) => {
//             state.isLoading = false;
//             state.tableData = action.payload;
//         });
//         builder.addCase(STPMachineryOperationPostDataAPI.rejected, (state, action) => {
//             console.log("Error", action.payload);
//             state.isLoading = false;
//             state.isError = true;
//             state.tableData = null;
//             // toastErrorr('Something went wrong')
//         });
//     },
// })

// export const STPMachineryOperationPostDataReducer = STPMachineryOperationPostDataSlice.reducer

// -----------------Delete API ---------------

export const STPBreakDownMaintainanceDeleteAPI = createAsyncThunk("STPBreakDownMaintainanceDelete", async ({ data }) => {
    const {
        T_STP_BreakdownMaintenanceID,
        M_UserID,
        token,
        handleIsPost
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);


    var formdata = new FormData();
    formdata.append("T_STP_BreakdownMaintenanceID", T_STP_BreakdownMaintenanceID);
    formdata.append("M_UserID", M_UserID);
    var requestOptions = {
        method: 'DELETE',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    };

    fetch(`${BaseUrl}/APKDashboard/WEB_STP_T_STP_BreakdownMaintenance_Delete`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.status) {
                handleIsPost()
                toastSuccesss(result.message)
            } else {
                toastErrorr(result.message)

            }
            return result

        })
})

const STPBreakDownMaintainanceDeleteSlice = createSlice({
    name: "STPBreakDownMaintainanceDelete",
    initialState: {
        isDeleteLoading: false,
        SectorData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(STPBreakDownMaintainanceDeleteAPI.pending, (state, action) => {
            state.isDeleteLoading = true;
        });
        builder.addCase(STPBreakDownMaintainanceDeleteAPI.fulfilled, (state, action) => {
            state.isDeleteLoading = false;
            state.SectorData = action.payload;

        });
        builder.addCase(STPBreakDownMaintainanceDeleteAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isDeleteLoading = false;
            state.isError = true;
            state.SectorData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const STPBreakDownMaintainanceDeleteReducer = STPBreakDownMaintainanceDeleteSlice.reducer